module.exports = {
  phoneNumber: "+971 52 559 0764",
  email: "info@altiusmedsupply.com",
};
